import { z } from 'zod';
import {
  EmbedContentFieldSchema,
  FieldGroupSchema,
  FieldRole,
  BlockType,
  ColorSchemeSchema,
  RichTextFieldSchema,
} from './Types';

export enum EmbedLayout {
  Right = 'right',
  Left = 'left',
  Center = 'center',
  NoText = 'noText',
}

export const EmbedOptionsSchema = z.object({
  subheaderEnabled: z.boolean().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
  layout: z.nativeEnum(EmbedLayout).optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

export type EmbedOptions = z.infer<typeof EmbedOptionsSchema>;

export const EmbedHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});
export const EmbedSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

export const EmbedHeaderAndSubheaderFieldGroupField = z.discriminatedUnion('name', [
  EmbedHeaderFieldSchema,
  EmbedSubheaderFieldSchema,
]);

export const EmbedHeaderAndSubheaderFieldGroupFieldSchema = FieldGroupSchema.extend({
  fields: z.array(EmbedHeaderAndSubheaderFieldGroupField),
});
export type EmbedHeaderField = z.infer<typeof EmbedHeaderFieldSchema>;
export type EmbedSubheaderField = z.infer<typeof EmbedSubheaderFieldSchema>;
export const EmbedContentFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(
    EmbedContentFieldSchema.extend({
      name: z.literal('embedContent'),
      role: z.literal(FieldRole.EmbedContent),
    }),
  ),
});
export type EmbedContentFieldGroup = z.infer<typeof EmbedContentFieldGroupSchema>;

export const EmbedBlockConfigSchema = z.object({
  options: EmbedOptionsSchema,
  type: z.literal(BlockType.Embed),
  fieldGroups: z.tuple([EmbedHeaderAndSubheaderFieldGroupFieldSchema]).rest(EmbedContentFieldGroupSchema),
  version: z.literal(1),
});
